// extracted by mini-css-extract-plugin
export default {"root":"_3DDVJ2hd","timerPeriod":"_2UHCCiUk","counter":"_21fUs0XI","label":"_3_oz3GGy"};